<ion-header [class.collapsed]="isCollapsed" [style.--collapse-progress]="collapseProgress">
  <!-- Main toolbar -->
  <ion-toolbar class="team-header-toolbar">
    <!-- Left -->

    <!-- Collapsible center content -->
    <div class="toolbar-content">
      <ion-buttons slot="start">
        <ion-button>
          <ion-back-button defaultHref="/my-teams"></ion-back-button>
        </ion-button>
      </ion-buttons>

      <!-- Team logo/avatar -->
      <div class="content-width toolbar-content">
        @if (team) {
        @if (isAbbreviationShow) {
        <div [class.team-logo]="!isCollapsed" [class.team-logo]="isCollapsed" slot="start">
          <div class="team-avatar" [ngStyle]="{ 'backgroundColor': this.getTeamColor(team, 'away') }">
            {{ getTeamAbbreviation(team) }}
          </div>
        </div>
        } @else if (team?.profile_image) {
        <img class="team-logo"
          [src]="team?.profile_image?.imageUrls?.medium || team?.profile_image || team?.profile_image?.medium"
          (error)="isAbbreviationShow = true" />
        } @else if (team?.organisations?.[0]?.organisationAbbreviation === 'ITA' && ITAlogo) {
        <img class="team-logo" [src]="ITAlogo" (error)="isAbbreviationShow = true" />
        } @else {
        <div [class.team-logo]="!isCollapsed" [class.team-logo]="isCollapsed" slot="start">
          <div class="team-avatar" [ngStyle]="{ 'backgroundColor': this.getTeamColor(team, 'away') }">
            {{ getTeamAbbreviation(team) }}
          </div>
        </div>
        }
        }
        <ion-item>
          <ion-label [ngClass]="isOwner || !canFollow ? 'owner team-name' : 'not-owner team-name'">
            {{ team?.name }}
            <p class="type" *ngIf="team && !isCollapsed">
              <span *ngIf="team.type">{{ team.type.name }}</span>
              <span *ngIf="team.subtype?.name"> | {{ team.subtype.name }}</span>
            </p>
            <div class="role-badges">
              <ion-badge *ngIf="isOwner" class="black-badge">
                Staff
              </ion-badge>

              <ion-badge *ngIf="!canFollow" class="black-badge">
                Fan
              </ion-badge>
            </div>
          </ion-label>
        </ion-item>

        <!-- Team name -->
        <div *ngIf="!isOwner && canFollow && !isUserTeamPlayer" style="justify-content: space-between; display: flex; flex-direction: row; flex: 1;">
          <div class="join-team" style="margin-left: 16px;">
            <ion-button (click)="onJoinTeamClick()" *ngIf="authService.authUserSignal()" class="follow-badge">
              Join Team
            </ion-button>
          </div>
        </div>
      </div>
    </div>



    <!-- Right -->
    <ion-buttons slot="end">
      <div class="share-bg">
        <ion-button (click)="shareTeamLink()" fill="clear" class="adaptive-share">
          <ion-icon slot="icon-only" name="share-outline"></ion-icon>
        </ion-button>

        <ion-button *ngIf="isOwner || !canFollow" (click)="onShowTeamPopover($event)">
          <ion-icon slot="icon-only" class="custom-icon" name="settings-sharp"></ion-icon>
        </ion-button>
      </div>
    </ion-buttons>
  </ion-toolbar>

  <!-- <ion-toolbar class="content-width" *ngIf="team?.organisations?.length">
    <div class="season-select-center">
      <app-season-selector #seasonSelector [organisationId]="team.organisations[0]._id"></app-season-selector>
    </div> 
  </ion-toolbar> -->
  <ion-toolbar class="content-width custom-toolbar">
    <ion-segment #segment (ionChange)="onSegmentChange($event)" [scrollable]="true" [value]="segmentValue">
      <ng-container *ngFor="let btn of segmentButtons">
        <ion-segment-button *ngIf="btn.visible" [value]="btn.value">
          <ion-label>{{ btn.label | translate }}</ion-label>
        </ion-segment-button>
      </ng-container>
    </ion-segment>
  </ion-toolbar>

  <ion-toolbar *ngIf="segment?.value === 'players'" class="content-width secondary-toolbar">
    <ion-segment #innerSegment (ionChange)="onInnerSegmentChange($event)" [scrollable]="true"
      [value]="innerSegmentValue">
      <ng-container *ngFor="let btn of innerSegmentButtons">
        <ion-segment-button *ngIf="btn.visible" [value]="btn.value">
          <ion-label>{{ btn.label | translate }}</ion-label>
        </ion-segment-button>
      </ng-container>
    </ion-segment>
  </ion-toolbar>
</ion-header>